import { AddOutlined } from "@qivia/ui";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AddDepartmentModal } from "./modals/addDepartmentModal";
import { SharedInterfaceDepartments } from "./sharedInterface";
import { DepartmentSidePanel } from "./sidePanel/SidePanel";
import { SidePanelDepartmentTypeDisplayed } from "./departmentsApi";

export const Departments = () => {
  const env = import.meta.env["VITE_TARGET_ENV"] as string;
  const firstPath = location.pathname.split("/")[1]; 
  const navigate = useNavigate();

  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    if (env === "production") {
      navigate("/home");
    }
  }, [env, navigate]);

  const sidePanelAction = useCallback(
    (props: Partial<SidePanelDepartmentTypeDisplayed>) => {
      navigate(`/${firstPath}/departments/${props.id}`);
    },
    [firstPath, navigate],
  );

  const cta = {
    title: t("departments.cta"),
    action: () => {
      setIsModalVisible(true)
    },
    width: 12,
    leftIcon: <AddOutlined />,
  };

  return (
    <>
      <AddDepartmentModal
        visible={isModalVisible}
        onCloseModal={() => {
          setIsModalVisible(false);
        }}
      />
      <SharedInterfaceDepartments 
        cta={cta}
        sidePanelAction={sidePanelAction}
        sidePanel={
          <DepartmentSidePanel
            canAddVehicle
            canDeactivate        
          />
        }
      />
    </>
  );
};
